function AboutPic() {
    return (
      <div>
        <img className="about-pic" src={require("../assets/floyd_two.jpg")} alt="Alex Floyd" />
      </div>
    );
  }
  
  export default AboutPic;
  